/// <reference types="vite/client" />

// Em dev, o Vite proxy redireciona /api para o backend (mesmo origin).
// Em Docker, Nginx faz o proxy. Em ambos os casos, API_BASE_URL é "".
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "";
